// extracted by mini-css-extract-plugin
export default {"panel":"o9k4XhwqyO3VhbdTflAG"};